<div class="chat-list__viewport">
  <div class="chat-list" #scroller (scroll)="onScroll()">
    <div class="chat-list__loader" *ngIf="store.loadingOlder()">
      <i class="pi pi-spin pi-spinner"></i>
    </div>

    <div class="chat-list__loading" *ngIf="store.loadingThread()">
      <i class="pi pi-spin pi-spinner"></i>
      Loading messages…
    </div>

    <div class="chat-list__empty" *ngIf="!store.loadingThread() && !rendered().length">
      <i class="pi pi-comments"></i>
      <p>No messages yet</p>
      <span>Say hello to start the conversation.</span>
    </div>

    <ng-container *ngFor="let entry of rendered(); trackBy: trackByMessage">
      <div class="chat-list__day" *ngIf="entry.daySeparator">
        <span>{{ entry.daySeparator }}</span>
      </div>

      <app-chat-message [message]="entry.message" [grouped]="entry.grouped" [canModerate]="store.isActiveGroupOwner()"></app-chat-message>
    </ng-container>
  </div>

  <!--
    Two shapes, one button: a bare arrow when the user has simply scrolled up, and a labelled pill
    once something has actually arrived below the fold — which is the only time there is news worth
    naming rather than just a way back down.
  -->
  <button
    type="button"
    class="chat-list__jump"
    [class.has-unseen]="unseenCount > 0"
    *ngIf="showJumpButton"
    (click)="jumpToLatest()"
    [attr.aria-label]="unseenLabel || 'Jump to latest message'">
    <i class="pi pi-arrow-down"></i>
    <span class="chat-list__jump-label" *ngIf="unseenLabel">{{ unseenLabel }}</span>
  </button>
</div>

<!--
  Outside the scroller on purpose.

  Typing is a *now* signal — it is only worth anything while it is true, and it stops being true
  within a couple of seconds. Rendered as the last row of the transcript it was visible exactly
  when it was needed least: scroll up to re-read anything and the one thing telling you a reply is
  on its way scrolls away with everything else. Pinned here it sits above the composer, where the
  reply is going to appear, and stays put whatever the transcript is doing.
-->
<p class="chat-list__typing" *ngIf="store.activeTypingLabel()" aria-live="polite">
  <span class="chat-list__dots"><i></i><i></i><i></i></span>
  {{ store.activeTypingLabel() }}
</p>
